/* Version: 3.5.155 */
'use client';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'react';
import PropTypes from 'prop-types';
import { safeRest } from '../../utils/functions.js';
import safeCustomStyle from '../../utils/safeCustomStyle.js';
import { ACCORDION_VARIANT } from './constants.js';
import { BodyWrapper } from './styledComponents.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["id", "ariaLabelledBy", "isExpanded", "customStyle", "children", "variant"];
var Body = function Body(_ref) {
  var id = _ref.id,
    ariaLabelledBy = _ref.ariaLabelledBy,
    _ref$isExpanded = _ref.isExpanded,
    isExpanded = _ref$isExpanded === undefined ? false : _ref$isExpanded,
    _ref$customStyle = _ref.customStyle,
    customStyle = _ref$customStyle === undefined ? {
      bodyStyle: {}
    } : _ref$customStyle,
    children = _ref.children,
    _ref$variant = _ref.variant,
    variant = _ref$variant === undefined ? ACCORDION_VARIANT.PRIMARY : _ref$variant,
    rest = _objectWithoutProperties(_ref, _excluded);
  var safeProps = safeRest(rest);
  var _safeCustomStyle = safeCustomStyle(customStyle),
    bodyStyle = _safeCustomStyle.bodyStyle;
  return /*#__PURE__*/jsx(BodyWrapper, _objectSpread(_objectSpread({}, safeProps), {}, {
    id: id,
    "aria-labelledby": ariaLabelledBy,
    isExpanded: isExpanded,
    variant: variant,
    bodyStyle: bodyStyle,
    children: children
  }));
};
process.env.NODE_ENV !== "production" ? Body.propTypes = {
  /** id for body wrapper */
  id: PropTypes.string,
  /** idREF for aria-labelledBy attribute */
  ariaLabelledBy: PropTypes.string,
  /** current state of expansion panel */
  isExpanded: PropTypes.bool,
  /** element for body of accordion */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  /** Which style of accordion to use */
  variant: PropTypes.oneOf([ACCORDION_VARIANT.PRIMARY, ACCORDION_VARIANT.SECONDARY, ACCORDION_VARIANT.LEGAL]),
  /** style overrides for body wrapper */
  customStyle: PropTypes.shape({
    bodyStyle: PropTypes.object
  })
} : undefined;
process.env.NODE_ENV !== "production" ? Body.displayName = 'Body' : undefined;

export { Body as default };
